import { BooleanParamNames, ColorParamNames, FontParamNames, NumberParamNames, TextParamNames, } from './thank-you-page-style-params';
var ThankYouPageStyleParams = {
    BooleanParamNames: BooleanParamNames,
    ColorParamNames: ColorParamNames,
    FontParamNames: FontParamNames,
    NumberParamNames: NumberParamNames,
    TextParamNames: TextParamNames,
};
export { ThankYouPageStyleParams };
//# sourceMappingURL=index.js.map